import { Component, Input } from '@angular/core';

@Component({
  selector: 'sx-metadata',
  templateUrl: 'metadata.component.html'
})
export class MetadataComponent {
  @Input() metadata;
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/atributos/metadata/metadata.component.ts